export default "__VITE_ASSET__BFPzKMrW__"